import React, { Component } from 'react';
import { Button, FormGroup, Checkbox } from 'react-bootstrap';

class BackupCodeDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmed: false
        };
    }

    handleDownload = () => {
        const { backupCodes } = this.props;
        const blob = new Blob([backupCodes.join('\n')], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'backup-codes.txt';
        a.click();

        URL.revokeObjectURL(url);
    };

    handleCopy = () => {
        const { backupCodes } = this.props;
        if (navigator.clipboard) {
            navigator.clipboard.writeText(backupCodes.join('\n'))
                .then(() => alert('Backup codes copied to clipboard!'))
                .catch(() => alert('Copy failed'));
        }
    };

    handleCheckboxChange = () => {
        this.setState(prevState => ({ confirmed: !prevState.confirmed }));
    };

    handleFinish = () => {
        if (this.props.onComplete) {
            this.props.onComplete();
        }
    };

    render() {
        const { backupCodes } = this.props;
        const { confirmed } = this.state;

        return (
            <div className="mt-4 p-3 border rounded">
                <h4>Backup Codes</h4>
                <p className="text-muted">
                    Save these codes in a secure place. Each code can only be used once.
                </p>

                <pre className="bg-light p-3 rounded" style={{ fontSize: '1.1rem' }}>
                    {backupCodes.join('\n')}
                </pre>

                <div className="mt-3">
                    <Button bsStyle="primary" onClick={this.handleDownload}>
                        Download Codes
                    </Button>
                    {' '}
                    <Button bsStyle="default" onClick={this.handleCopy}>
                        Copy to Clipboard
                    </Button>
                </div>

                <FormGroup className="mt-3">
                <Checkbox
                    checked={this.props.confirmed}
                    onChange={() => this.props.onConfirmChange(!this.props.confirmed)}
                >
                    I’ve saved my backup codes
                </Checkbox>

                </FormGroup>
            </div>
        );
    }
}

export default BackupCodeDisplay;
